import _ from 'lodash'
import moment from 'moment'

/**
 * Constructs a hash of "days of the week" (see #14025 #14026)
 * e.g. { 'sunday': 'Sunday', ... }
 */

const keys = [ 'sunday', 'monday', 'tuesday', 'wednesday', 'thursday',
	'friday', 'saturday']
const m = moment()
const daysOfTheWeek = _.transform(keys, (result, month, index) => {
	m.day(index)
	result[month] = m.format('dddd')
}, {})

// we have to return a function because if we just returned the days by
// themselves, iterating over them would return the file path as one of the
// properties (i.e. __fileName__: scripts/scoreboard/components/days-of-the-week.js)
export default () => daysOfTheWeek
export { keys }
